module.exports = __webpack_public_path__ + "img/mail.dc4b356e.svg";